import { render, staticRenderFns } from "./CommodityPricing.vue?vue&type=template&id=424c5a50&scoped=true&"
import script from "./CommodityPricing.vue?vue&type=script&lang=js&"
export * from "./CommodityPricing.vue?vue&type=script&lang=js&"
import style0 from "./CommodityPricing.vue?vue&type=style&index=0&id=424c5a50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c5a50",
  null
  
)

export default component.exports